import {Component} from 'preact';
import pick from 'ramda/src/pick';
import equals from 'ramda/src/equals';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import cx from 'classnames';

class ProgressMeter extends Component {

    shouldComponentUpdate ( nextProps, nextState ) {
        const propList = ['value'];

        return !equals(
            pick( propList, nextProps ),
            pick( propList, this.props )
        );
    }

    render () {

        const {
            className = '',
            value,
            labelLeft,
            labelRight,
            focusable,
            animated,
            color = 'brand',
            height = 6,
            ...resetProps
        } = this.props;

        const progressItemClassName = cx( 'progress-meter-item flex items-center', className,
            {'focusable': focusable}
        );
        const progressMeterClassName = cx( 'progress-meter flex-1', `h-${height}` );
        const progressValueClassName = cx(
            'progress-meter-value',
            `bg-${color}`,
            {'progress-meter-value--on': animated}
        );

        const progressValue = parseFloat( value ).toFixed( 2 );

        // "tabIndex" attribute is required for :focus, :active states with focusable attribute
        const tabIndex = focusable ? {tabIndex: 0} : {};

        return (
            <div className={progressItemClassName} {...tabIndex} {...resetProps} data-testid="test-progressMeter">
                {!isEmptyOrNil( labelLeft ) && <div className="flex-0 w-16 text-sm">{labelLeft}</div>}
                <div className={progressMeterClassName}>
                <span data-progress-value={progressValue}
                      className={progressValueClassName}/>
                </div>
                {!isEmptyOrNil( labelRight ) && <div className="flex-0 w-16 text-right">{labelRight}</div>}
            </div>
        );
    }
};

export default ProgressMeter;